import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function ThumbsDownIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props} viewBox="0 0 21 20">
			<path
				d="M16.4482 10.754L18.7518 10.754C19.4718 10.754 20.0554 10.1729 20.0554 9.45599L20.0554 1.30148C20.0554 0.584594 19.4718 0.00344271 18.7518 0.00344265L16.4482 0.00344245C15.7283 0.00344239 15.1446 0.584593 15.1446 1.30148L15.1446 9.45599C15.1446 10.1729 15.7283 10.754 16.4482 10.754Z"
				fill={props.fill}
			/>
			<path
				d="M1.41396 5.57625C1.33896 6.04567 0.560376 6.52933 0.503233 7.10544C0.44609 7.68867 1.13538 8.21144 1.13538 8.82667C1.13538 9.45257 0.456804 9.91844 0.506805 10.5479C0.535376 10.932 1.46753 12.2051 1.68539 12.2051L7.22117 12.2051C7.32831 14.1255 5.62115 15.1675 5.86044 17.2657C5.96401 18.1725 6.63902 19.6128 7.57117 19.8867C9.93906 20.5872 9.29976 17.8774 10.0105 16.2273C10.4033 15.3169 13.257 11.942 14.1177 10.6902C13.9605 10.3985 13.8712 10.0643 13.8712 9.70863L13.8712 1.04201C13.8712 0.910431 13.8855 0.778849 13.9105 0.654379C11.5105 -0.0533163 3.95328 -0.273807 3.07827 0.430333C2.32111 1.03845 2.78898 2.01287 2.49969 2.52497C2.3604 2.77035 1.41396 2.80947 1.1961 3.5634C0.967525 4.34934 1.49967 5.02503 1.41039 5.57625L1.41396 5.57625Z"
				fill={props.fill}
			/>
		</SvgIcon>
	);
}
